import styled from 'styled-components';

export const StyledMainMenu = styled.div`
  display: flex;
  width: 100vw;
  height: calc(100% - 40px);
  position: fixed;
  left: ${props => (props.isOpened ? '0' : '-100vw')};
  top: 40px;
  background: #fbfbfb;
  z-index: 2000;
  flex-direction: column;
  padding: 20px 12px;
  transition: left 0.5s ease;
`;

export const StyledBookTitle = styled.p`
  margin: 0 0 0.75rem;
  color: #1d1d1f;
  font-size: 14.22px;
`;

export const StyledBookAuthors = styled.p`
  margin: 0 0 1.5rem;
  color: #4f4f4f;
  font-size: 12.64px;
`;

export const StyledLine = styled.hr`
  width: 100%;
  border: 0.5px solid #c8c8c8;
  margin-top: 0;
  margin-bottom: 1.25em;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const BetaWrapper = styled.div``;

export const BetaButton = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
  font-size: 14.22px;
  font-family: inherit;
  color: #0f4c81;
  display: flex;
  align-items: center;
  cursor: pointer;

  > span {
    margin-left: 8px;
  }
`;
